import React from "react";
import { Head } from "../../components";
import { AdminTabs } from "../../components";
import "./admindashboard.css";

const AdminDashboard = () => {
  return (
    <>
      <div className="admindashboard-g">
        <Head title="Admin Dashboard" />
        <div className="admin-todo-container">
          <AdminTabs />
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;